import { TriggerApi } from '@voladeum/client';
import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';
import { uuidv4 } from 'utils/uuid';

import { EMPTY_ARRAY } from '../../../constants';
import { normalizeConditions } from '../conditions/normalizers';

import { Trigger } from './types';

export const normalizeTriggers = (triggers: TriggerApi[] = EMPTY_ARRAY) =>
  triggers.map((trigger) => normalizeTrigger(trigger));

export const normalizeTrigger = (trigger: TriggerApi): Trigger => {
  return {
    ...trigger,
    position_pct_formatted: formatValue(trigger.position_pct, { format: FORMAT_TYPE.PERCENT }),
    weight_formatted: formatValue(trigger.weight, { format: FORMAT_TYPE.NUMBER }),
    conditions: normalizeConditions(trigger.conditions || EMPTY_ARRAY),
    uuid: uuidv4(),
  };
};
